/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { Decoder as IODecoder, Encoder as IOEncoder, Packet, PacketType } from 'socket.io-parser';

import PacketParser from './packetparser';
import ParserUtils from './parserutils';

export const ENCODED_TYPES: PacketType[] = /* #__PURE__ -- @preserve */ ( () => [
	PacketType.EVENT,
	PacketType.ACK,
	PacketType.BINARY_ACK,
	PacketType.BINARY_EVENT
] )();

export class Encoder extends IOEncoder {
	private readonly _packetParser: PacketParser;

	public constructor( packetParser?: PacketParser ) {
		super();

		this._packetParser = packetParser ?? new PacketParser();
	}

	public encode( packet: Packet ): unknown[] {
		const isEncodable: boolean = ENCODED_TYPES.includes( packet.type );

		if ( isEncodable ) {
			try {
				const encodedPacket: Buffer = this._packetParser.encode( packet.type, packet.data, packet.id, packet.nsp );

				return [ encodedPacket ];
			} catch ( error ) {
				console.error(
					'Can not properly serialize or deserialize messages. Check the original error.',
					{ originalError: { message: error.message } }
				);
			}
		}

		return super.encode( packet );
	}
}

export class Decoder extends IODecoder {
	private readonly _packetParser: PacketParser;

	public constructor( packetParser?: PacketParser ) {
		super();

		this._packetParser = packetParser ?? new PacketParser();
	}

	public add( obj: Buffer | unknown ): void {
		if ( !ParserUtils.isBuffer( obj ) ) {
			return super.add( obj );
		}

		let packet: Packet;

		try {
			const decoded: { packet: Packet; } = this._packetParser.decode( obj );

			packet = decoded.packet;
		} catch ( error ) {
			return super.add( obj );
		}

		super.emitReserved( 'decoded', packet );
	}
}
